<template>
    <div class="pagination-sizes">
        Show by:
        <div class="list">
            <button v-for="size of pageSizes"
                    :key="size"
                    :disabled="active(size)"
                    :class="{active: active(size)}"
                    class="size"
                    @click="setActivePageSize(size)"
            >{{ size }}</button>
        </div>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';

    export default {
        name: "PaginationSizes",

        emits: [
            'changedPageSize',
        ],

        props: [
            'current'
        ],

        computed: {
            ...mapState('pagination', [
                'pageSizes',
                'pageSize',
            ]),

        },

        methods: {
            ...mapActions('pagination', [
                'setPageSize',
            ]),

            async setActivePageSize(size) {

                await this.setPageSize(size);

                this.setRouteQuery(size);

                this.$emit('changedPageSize', size);
            },

            setRouteQuery() {
                // go to page=1 after the pagination size change
                const page = 1;
                const query = { ...this.$route.query, page };
                const route = { path: this.$route.path, query };

                this.$router.push(route);
            },

            active(size) {
                return +this.pageSize === +size;
            },

        },

    }
</script>

<style scoped>
    .pagination-sizes {
        display: flex;
    }

    .list {
        padding-left: 2px;
    }

    .size {
        margin: 0 5px;
        padding: 0 1px;
        border: none;
        border-bottom: 1px solid;
        font-size: inherit;
        color: #3479a3;
        background: transparent;
    }

    .active,
    .size:hover {
        color: #0a4d75;
    }

    .active {
        border-width: 2px;
        font-weight: 700;
    }
</style>